import { flow, initial, last, set } from "lodash";
import { useSettings } from "@/store/settings";
import axios from "axios";

// Adding a XYZ.js into the namespaces folder will automatically make it available
const modules = import.meta.glob("./namespaces/**.js", { eager: true });

// Takes a path and returns a module name
const getModuleName = flow([(key) => key.split(/[/.]+/g), initial, last]);

const getModule = (mod) => mod.default;

const mapped = Object.entries(modules).reduce((acc, [name, mod]) => {
  acc[getModuleName(name)] = getModule(mod);
  return acc;
}, {});

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json"
  },
});

export function parseBody(response) {
  return Promise.resolve(response.data ?? response)
}

export function err(error) {
  return Promise.reject(error);
}

instance.interceptors.request.use((config) => {
  if (!config.headers) config.headers = {};
  config.headers["Cache-Control"] = "no-cache";
  config.headers["Pragma"] = "no-cache";
  config.headers["Expires"] = "0";
  return config;
});

instance.interceptors.response.use(parseBody, err);

let api = {};

/**
 * Generates an object with this shape
 * { namespace:  { action: (data, config) => axios(requestData) } }
 * Example
 * { users: { create: (data) => axios(), get: id => axios } }
 */
Object.entries(mapped).forEach(([name, module]) => {
  Object.entries(module).forEach(([method, endpoints]) => {
    Object.entries(endpoints).forEach(([endpoint, parseParams]) => {
      // e.g. api.users.getAll = () => axios(...)
      set(api, [name, endpoint], (data = {}, additional = {}) => {
        const [url, content] = parseParams(data, additional);
        let body = {
          method,
          url,
        };
        //Only attach a body when the method allows
        if (["post", "put"].includes(method)) {
          body.data = content;
        }

        body = { ...body, ...additional };

        return instance(body);
      });
    });
  });
});

//This is the apiclient
export default api;
//This is the axios instance for misc calls
export { instance };
